import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

// Introductions across jobs with their dates: the dashboard queue and the
// detail page's queue position read this. (The candidates tab reads days
// waiting from the candidate list's `stateEnteredAt`.) Invalidate it from every mutation that moves a candidate into or
// out of review (see useCreateCandidateFeedbackMutation,
// useUpdateJobStateMutation).
export const candidateSubmissionsAwaitingReviewQueryKeys = {
  all: ['candidate-submissions', 'awaiting-review'] as const,
  list: (companyId?: string) =>
    [...candidateSubmissionsAwaitingReviewQueryKeys.all, companyId] as const,
};

export function useCandidateSubmissionsAwaitingReviewQuery(companyId?: string) {
  return useQuery({
    queryKey: candidateSubmissionsAwaitingReviewQueryKeys.list(companyId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(
        '/candidate-submissions/awaiting-review',
        {
          params: {
            query: companyId ? { companyId } : undefined,
          },
        },
      );
      return data;
    },
  });
}
